import { Component, Input, type OnInit } from '@angular/core';
import { NgrxFormsModule, FormGroupControls } from 'ngrx-forms';
import type { FullCalculateFormValues } from '@innogy/become-a-customer/shared';
import {
  CalculateComponentContent,
  type CalculateComponentRendering,
} from '@innogy/become-a-customer/shared/interfaces';
import { CommonUiFormsModule, type RadioItem } from '@innogy/common-ui/forms';
import {
  type ToolTip,
  ToolTipComponent,
} from '@legacy/common-ui-utility-components';
import { TypedComponentRendering } from '@core/jss-models';
import { CrntRadioGroup, CrntRadio } from '@essent/current-web-angular';

@Component({
  selector: 'wl-calculate-form-meter',
  templateUrl: './calculate-form-meter.component.html',
  standalone: true,
  imports: [
    ToolTipComponent,
    CrntRadioGroup,
    CrntRadio,
    NgrxFormsModule,
    CommonUiFormsModule,
  ],
})
export class CalculateFormMeterComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) content!: CalculateComponentContent;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() controls?: FormGroupControls<FullCalculateFormValues>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: TypedComponentRendering<CalculateComponentRendering>;

  radioButtonDescriptions: RadioItem<boolean>[] = [];
  popoverDescription?: ToolTip;

  ngOnInit() {
    this.radioButtonDescriptions = [
      {
        label: this.content.smartMeterRadioButtonLabel ?? '',
        value: true,
      },
      {
        label: this.content.regularMeterRadioButtonLabel ?? '',
        value: false,
      },
    ];
    this.popoverDescription = {
      description: this.content.doubleMeterCheckboxTooltip,
    };
  }
}
